import { render, staticRenderFns } from "./SolicitacaoAcessoDetalhar.vue?vue&type=template&id=68c6cfbc"
import script from "./SolicitacaoAcessoDetalhar.vue?vue&type=script&lang=js"
export * from "./SolicitacaoAcessoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports